import consumer from "./consumer"


const chatBox = document.querySelector('#js-chat-box');

if (chatBox) {

  const CURRENT_CONVERSATION_ID = chatBox.dataset.conversationId;
  if (!CURRENT_CONVERSATION_ID) {
    console.warn("GbrChannel: missing conversationId on #js-chat-box; subscription skipped.");
  } else {
    console.log("chat loaded. ConversationID:", CURRENT_CONVERSATION_ID)

    const cable = consumer || (window.App && window.App.cable);
    if (!cable) {
      console.warn("GbrChannel: missing ActionCable consumer; subscription skipped.");
    } else {
      cable.subscriptions.create({channel: "GbrChannel", conversation_id: CURRENT_CONVERSATION_ID},
      {
        connected() {
          // Called when the subscription is ready for use on the server
          console.log("gbr connected");
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
          console.log("gbr disconnected");
        },

        received(data) {
          // Called when there's incoming data on the websocket for this channel
          console.log(`gbr received data: ${JSON.stringify(data)}`);
          $('#give-back-modal').modal('hide');
          window.location.reload();

        }
      });
    }
  }
}
